import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import { Reveal } from "@/components/Reveal";
import { useSEO } from "@/hooks/useSEO";
import { PRODUCT_GROUPS } from "@/lib/site";

export default function Produk() {
  useSEO(
    "Produk & Layanan",
    "Kaos custom, polo, jersey printing, kemeja, jaket, hoodie, wearpack, seragam, bordir komputer, sablon plastisol, DTF, dan sublimasi — semua layanan konveksi HATTORY KONVEKSI."
  );

  return (
    <>
      <PageHero
        overline="Produk & Layanan"
        titleLines={["Produk &", "Layanan Kami"]}
        description="Dari pakaian jadi hingga teknik produksi, kami melayani kebutuhan apparel custom Anda dengan bahan pilihan dan pengerjaan yang rapi."
      />

      <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
        {PRODUCT_GROUPS.map((group, gi) => (
          <section key={group.group} className={gi > 0 ? "mt-20" : ""} data-testid={`product-group-${gi}`}>
            <Reveal>
              <div className="mb-8 flex items-center gap-4">
                <span className="text-xs font-bold uppercase tracking-[0.25em] text-silver">
                  {String(gi + 1).padStart(2, "0")}
                </span>
                <h2 className="text-3xl font-black tracking-tight text-navy md:text-4xl">{group.group}</h2>
                <span className="h-px flex-1 bg-silver/40" />
              </div>
            </Reveal>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {group.items.map((item, i) => (
                <Reveal key={item.name} delay={(i % 3) * 0.08}>
                  <div className="group h-full overflow-hidden rounded-3xl bg-white shadow-soft transition-transform duration-300 hover:-translate-y-1 hover:shadow-lift" data-testid={`product-card-${item.name.toLowerCase().replace(/\s+/g, "-")}`}>
                    <div className="h-52 overflow-hidden">
                      <img src={item.image} alt={item.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                    </div>
                    <div className="p-6">
                      <h3 className="text-xl font-bold tracking-tight text-navy">{item.name}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-charcoal/80">{item.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </section>
        ))}

        <Reveal>
          <div className="mt-20 flex flex-col items-center gap-5 rounded-3xl border border-silver/40 px-8 py-14 text-center">
            <h3 className="text-2xl font-bold text-navy md:text-3xl">Tidak menemukan yang Anda cari?</h3>
            <p className="max-w-xl text-charcoal/80">Tanya kami langsung — kami siap membantu mewujudkan kebutuhan apparel custom Anda.</p>
            <Link to="/kontak" data-testid="produk-contact-link" className="inline-flex items-center gap-2 rounded-full bg-navy px-8 py-4 font-medium text-white transition-transform duration-300 hover:scale-105">
              Hubungi Kami <ArrowUpRight className="h-5 w-5" />
            </Link>
          </div>
        </Reveal>
      </div>

      <CTABand />
    </>
  );
}
